import { AccessDeniedComponent, LoginComponent, SharedLogoutComponent } from '@agroone-front/shared'
import { AgropilotFeature, UserPermissions } from '@agroone/entities'
import { UserGuard } from './core/guards/user.guard'
import { Routes } from '@angular/router'

export const appRoutes: Routes = [
  { path: 'access-denied', component: AccessDeniedComponent },
  {
    path: 'logout',
    component: SharedLogoutComponent,
  },
  {
    path: 'auth/login',
    component: LoginComponent,
  },
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: () => import('./features/home/home.routes').then((m) => m.homeRoutes),
      },
      {
        path: 'home',
        loadChildren: () => import('./features/home/home.routes').then((m) => m.homeRoutes),
      },
      {
        path: 'crops',
        loadChildren: () => import('./features/offers/offers.routes').then((m) => m.offersRoutes),
        // canActivate: [UserGuard],
      },
      {
        path: 'planification',
        loadComponent: () =>
          import('./features/planification/planification.component').then((m) => m.PlanificationComponent),
        canActivate: [UserGuard],
        data: {
          agropilotFeature: AgropilotFeature.PLANNING,
        },
      },
      {
        path: 'user-preferences',
        loadComponent: () =>
          import('./features/user-preferences/user-preferences.component').then((m) => m.UserPreferencesComponent),
        canActivate: [UserGuard],
        data: {
          permissions: [UserPermissions.CROP_MODULE_ACCESS],
        },
      },
      {
        path: 'pc-radio',
        loadComponent: () => import('./features/pc-radio/pc-radio.component').then((m) => m.PcradioComponent),
        canActivate: [UserGuard],
        data: {
          agropilotFeature: AgropilotFeature.MONITORING,
        },
      },
      {
        path: 'suivi',
        loadChildren: () => import('./features/stocks/stocks.routes').then((m) => m.stocksRoutes),
        canActivate: [UserGuard],
        data: {
          agropilotFeature: AgropilotFeature.STOCK_TRACKING,
        },
      },
      {
        path: 'factories',
        loadComponent: () => import('./features/factories/factories.component').then((m) => m.FactoriesComponent),
        canActivate: [UserGuard],
        data: {
          agropilotFeature: AgropilotFeature.PLANT_ARRIVAL,
        },
      },
      {
        path: 'admin',
        loadChildren: () => import('./features/admin/admin.routes').then((m) => m.adminRoutes),
        canActivate: [UserGuard],
        data: {
          agropilotFeature: AgropilotFeature.ADMIN,
        },
      },
    ],
  },
  { path: '**', redirectTo: '' },
]
